import { GeneratedFormSpecTypes } from '@/utils/types/generatedForm'

export const keyActivitiesJobDescSpec: GeneratedFormSpecTypes[] = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Key Activities',
    name: 'KeyActivities',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Job Description',
    name: 'JobDesc',
    type: 'text',
  },
]
